<table mat-table matSort [dataSource]="serie.images" class="rx-image-table">
    <ng-container matColumnDef="image">
        <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
        <td mat-cell *matCellDef="let image">
            <img src="{{thumbnail(image)}}" (click)="selectImage(image)">
        </td>
    </ng-container>
    <tr class="hide-header" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
